// extracted by mini-css-extract-plugin
module.exports = {"img-text-card-box":"gm","imgTextCardBox":"gm","text-box":"gn","textBox":"gn","remark-val":"go","remarkVal":"go"};